<template>

    <v-select
        :loading="loading"
        :disabled="loading"
        :outlined="outlined"
        class="no-line-select"
        xs6
        hide-details
        :items="bidStages"
        :label="label"
        item-text="id"
        return-object
        :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
        v-model="currentStage"
    >
      <template v-slot:selection="{ item }">

      <span class="text-no-wrap">
            <span
                :style="{ width:'11px', height:'11px', background: item.color, color: getCorrectTextColor(item.color)}"
                class="pa-1 d-inline-block mr-1 status-square"></span>
            {{ item.is_system ? $t('viewBids.stages.' + item.system_name) : item.name }}

      </span>
      </template>
      <template v-slot:item="{ item }">
      <span class="text-no-wrap">

            <span
                :style="{width:'11px', height:'11px', background: item.color, color: getCorrectTextColor(item.color)}"
                class="pa-1 d-inline-block mr-1 status-square"></span>
            {{ item.is_system ? $t('viewBids.stages.' + item.system_name) : item.name }}

      </span>
      </template>
    </v-select>

</template>
<script>
import CommonMixin from "@/mixins/common";
export default {
  name: "BidStageSelect",
  props: {
    outlined:null,
    bidStages: Array,
    stage: Object,
    label: null,
    loading: Boolean
  },
  mixins: [CommonMixin],
  data: () => ({
    //stage:null
  }),
  computed:{
    currentStage:{
      get(){
        return this.stage
      },
      set(stage){
        this.$emit('update', stage)
      }
    }
  },
  methods: {
    updateBidStage(){}
  },
};
</script>
